var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('video',{attrs:{"src":_vm.$route.query.videoUrl,"controls":"controls","autoplay":"autoplay","width":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }